import { authenticationService } from "./authenticationService";

/**
 * Llamadas al puente de la encuesta de satisfacción en rcf-api.
 *
 * Se autentican con el JWT que `checkonhis` devuelve al entrar (queda en
 * `currentUser.tokens`); correo y nombre los pone el backend a partir de ese
 * token, nunca este front. Si el acceso vence mientras la persona responde,
 * se renueva una vez con el refresh token.
 */

const URL_BASE = process.env.REACT_APP_URL_HOST + "/cerotram";
const TIMEOUT_MS = 15000;

// Acceso renovado en memoria, atado al refresh que lo generó: si otra persona
// entra en la misma pestaña, su refresh es otro y este valor deja de usarse.
let renovado = { refresh: null, access: null };

const tokens = () => authenticationService.currentUserValue?.tokens || {};

function accesoVigente() {
  const { access, refresh } = tokens();
  return refresh && renovado.refresh === refresh ? renovado.access : access;
}

async function pedir(ruta, cuerpo, acceso) {
  const control = new AbortController();
  const vigilante = setTimeout(() => control.abort(), TIMEOUT_MS);
  try {
    return await fetch(URL_BASE + ruta, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(acceso ? { Authorization: `Bearer ${acceso}` } : {}),
      },
      body: JSON.stringify(cuerpo),
      signal: control.signal,
    });
  } finally {
    clearTimeout(vigilante);
  }
}

async function renovarAcceso() {
  const { refresh } = tokens();
  if (!refresh) return null;
  const respuesta = await pedir("/api/token/refresh/", { refresh });
  const datos = respuesta.ok ? await respuesta.json() : null;
  if (typeof datos?.access !== "string") return null;
  renovado = { refresh, access: datos.access };
  return datos.access;
}

async function post(ruta, cuerpo) {
  let acceso = accesoVigente();
  if (!acceso) throw new Error("sin_sesion");

  let respuesta = await pedir(ruta, cuerpo, acceso);
  if (respuesta.status === 401) {
    acceso = await renovarAcceso();
    if (!acceso) throw new Error("sin_sesion");
    respuesta = await pedir(ruta, cuerpo, acceso);
  }
  if (!respuesta.ok) throw new Error(`http_${respuesta.status}`);
  return respuesta.json();
}

const cuerpoCon = (cliId, nit) => ({
  cli_id: cliId == null ? "" : String(cliId),
  ...(nit ? { nit_clinica: nit } : {}),
});

export const encuestaSatisfaccionService = {
  /** Si hay encuesta: `{ elegible: true, url }`; si no, `{ elegible: false, motivo }`. */
  preparar: (cliId, nit) => post("/encuestas/render-token", cuerpoCon(cliId, nit)),
  /** `{ completada: boolean, degradado?: true }`, siempre revalidado por el backend. */
  confirmar: (cliId, nit) => post("/encuestas/estado", cuerpoCon(cliId, nit)),
};
